import { CommonModule } from '@angular/common';
import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges, TemplateRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { BaseChart } from 'src/app/core/data/model';

import { ShowLoadingComponentState } from '../../../bloc/base-bloc';
import {
  ChartCardCallerCallBack,
  ChartsCardBloc,
  ChartsCardInitEvent,
  ChartsCardReadyState,
  ChartsCardState,
} from '../../../bloc/chart-card-bloc';
import { BaseComponent } from '../../base-component/base.component';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { ChartCardDefaultHeaderComponent } from '../chart-card-default-header/chart-card-default-header.component';
import { FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { ThemesService } from 'src/app/core/services/themes.service';

@Component({
  selector: 'app-generic-chart-card',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent,
    TranslateModule,
    ChartCardDefaultHeaderComponent,
    ChartCardDefaultHeaderComponent,
    ReactiveFormsModule
  ],
  templateUrl: './generic-chart-card.component.html',
  styleUrls: ['./generic-chart-card.component.scss'],
  providers: [ChartsCardBloc]
})
export class GenericChartCardComponent<ChartData extends BaseChart> extends BaseComponent implements OnInit , OnChanges {
  contentData: ChartData;
  showLoading: boolean = false;
  form : FormGroup;

  // inputs
  @Input() headerTemplate: TemplateRef<any>;
  @Input() contentTemplate: TemplateRef<any>;
  @Input() filterTemplate: TemplateRef<any>;
  @Input() caller: ChartCardCallerCallBack<ChartData>;
  @Input() contentHeight : string = '200px';
  @Input() showReloadButton : boolean = false;
  @Input() showFiltersButton: boolean = false;
  @Input() showFiltersSearchButton: boolean = true;
  @Input() title: string;
  @Input() filterSearchKey: string = 'search';

  // constructor
  constructor(private bloc: ChartsCardBloc, injector: Injector) {
    super([], injector);
    this.bloc.onState.pipe(takeUntil(this.destroy$)).subscribe((state) => this.onHandleState(state));
  }
  // hooks
  ngOnInit(): void {
    this.form = this.injector.get(FormGroupDirective).form;
  }

  ngOnChanges(changes : SimpleChanges) : void{
    if(changes && changes?.["caller"]?.currentValue){
      this.bloc.setEvent.next(new ChartsCardInitEvent(this.caller));
    }
  }

  onRefresh(isRefreshed: boolean) {
    if(isRefreshed) {
      this.bloc.setEvent.next(new ChartsCardInitEvent(this.caller));
    }
  }

  // privates
  private onHandleState(state: ChartsCardState) : void {
    this.showLoading = false;
    if (state instanceof ShowLoadingComponentState) {
      this.showLoading = true;
    } else if (state instanceof ChartsCardReadyState) {
      this.contentData = state.data;
    }
  }
}
